export const BaseUrl = "https://api.thelpsedu.co.in/"
// export const BaseUrl = "http://localhost:8002/"


export const accessToken = localStorage.getItem("accessToken");
